// Coin prices: the only formatter is sdk/purchase/src/price.ts; the coin's name comes from COIN_NAME there.
//
// Every `≈` approximation uses the viewer's own country price (docs/build/pricing.md). The country comes from money's
// GET /v1/me/pricing: the billing country of the viewer's last checkout (accounts has no country field, and the IP is
// never used). Signed out, never checked out, or money unreachable: the USD fallback `500 ◆ (≈ $5.00)`.
export { COIN_NAME, COIN_SYMBOL, formatCents, type LocalPrice } from "../../../sdk/purchase/src/price.ts";
import { COIN_SYMBOL, formatCents, formatPrice as formatPriceIn, type LocalPrice } from "../../../sdk/purchase/src/price.ts";
import { api } from "./api.ts";

let viewer: LocalPrice | null = null;

/** The viewer's `LocalPrice`, or null when their country is unknown. */
export function viewerPrice(): LocalPrice | null {
  return viewer;
}

export function setViewerPrice(local: LocalPrice | null): void {
  viewer = local;
}

/**
 * Loads the signed-in viewer's prices from money (`GET /v1/me/pricing`). Signed out or on any error: the fallback.
 * `fetchPricing` is for tests.
 */
export async function loadViewerPrice(
  signedIn: boolean,
  fetchPricing: () => Promise<{ local: LocalPrice | null }> = () => api<{ local: LocalPrice | null }>("money", "/me/pricing"),
): Promise<LocalPrice | null> {
  if (!signedIn) return (viewer = null);
  try {
    viewer = (await fetchPricing()).local ?? null;
  } catch {
    viewer = null;
  }
  return viewer;
}

/** `500 ◆ (≈ €4.89)` in the viewer's currency, or `500 ◆ (≈ $5.00)` when their country is unknown. */
export function formatPrice(coins: number, local: LocalPrice | null = viewer): string {
  return formatPriceIn(coins, local);
}

/**
 * Creator payout for `coins` at `centsPer100` (from money: GET /v1/config `payout_cents_per_100_coins`, or a
 * statement's `rate_cents_per_100_coins`; the owner decided 78). Rounds down, as money's statements do.
 */
export function payoutCents(coins: number, centsPer100: number): number {
  return Math.floor((coins * centsPer100) / 100);
}

export function payoutDisplay(coins: number, centsPer100: number): string {
  return formatCents(payoutCents(coins, centsPer100));
}

export function rateDisplay(centsPer100: number): string {
  return `${centsPer100}¢ per 100 ${COIN_SYMBOL}`;
}
